import React from 'react';
import styled from 'styled-components/macro';
import { Row } from '.';

const RowProductView = styled(Row)`
  margin-left: -22px !important;
  margin-right: -22px !important;
`;

export default ({
  children,
}) => (
  <RowProductView>
    {children}
  </RowProductView>
);
